<template>
  <div>
    <h2>
      Warnings
    </h2>
    <el-form
      ref="form"
      :model="item"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Warning Charge Weight"
            prop="warn_chweight"
          >
            <el-input
              v-model="item.warn_chweight"
              type="number"
              placeholder="Warning Charge Weight"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Warning Length "
            prop="warn_length"
          >
            <el-input
              v-model="item.warn_length"
              type="number"
              placeholder="Warning Length"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }

  },
  data () {
    return {
      rules: {
        warn_chweight: [
          { required: true, message: 'Warning Charge Weight is required.', trigger: ['blur'] }
        ],
        warn_length: [
          { required: true, message: 'Warning Length  is required.', trigger: ['blur'] }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
